import { memo } from 'react';
import { useSelector } from 'react-redux';

import { Trash2Icon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { IconButton } from '@air/primitive-icon-button';
import { useBreakpointsContext } from '@air/provider-media-query';
import { useAirModal } from '@air/provider-modal';
import { hasSelectedItemsSelector } from '@air/redux-selected-items';

import { ContentCollectionDeleteClipsModal } from '~/components/ContentCollection/ContentCollectionDeleteClipsModal';
import { selectedClipsSelector } from '~/store/selectedItems/selectors';

export const ContentCollectionRemoveItemsButton = memo(() => {
  const { isAboveXLScreen } = useBreakpointsContext();

  const hasSelectedItems = useSelector(hasSelectedItemsSelector);
  const selectedClipItems = useSelector(selectedClipsSelector);

  const [showDeleteClipsModal] = useAirModal(ContentCollectionDeleteClipsModal);

  if (isAboveXLScreen) {
    return (
      <Button
        appearance="ghost"
        color="gray"
        /**
         * @TODO - Talked w/ design, this is a quick-fix here for content collection. We're going to be redoing disabled states in the next coming weeks.
         */
        className="disabled:bg-transparent disabled:opacity-40"
        data-testid="CONTENT_COLLECTION_REMOVE_ITEMS"
        disabled={!hasSelectedItems}
        // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
        onClick={() => showDeleteClipsModal({ clips: selectedClipItems })}
        size="medium"
        prefix={<Trash2Icon className="-mr-1" size="sm" />}
      >
        Delete selected
      </Button>
    );
  }

  return (
    <IconButton
      appearance="ghost"
      color="gray"
      /**
       * @TODO - Talked w/ design, this is a quick-fix here for content collection. We're going to be redoing disabled states in the next coming weeks.
       */
      className="disabled:bg-transparent disabled:opacity-40"
      data-testid="CONTENT_COLLECTION_REMOVE_ITEMS"
      disabled={!hasSelectedItems}
      adsIcon
      icon={Trash2Icon}
      label="Remove items"
      // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
      onClick={() => showDeleteClipsModal({ clips: selectedClipItems })}
      size="medium"
    />
  );
});

ContentCollectionRemoveItemsButton.displayName = 'ContentCollectionRemoveItemsButton';
